import { useCallback, useMemo, useState } from "react"

import { MoreHorizRoundedIcon, MoreVertRoundedIcon } from "@l2r-front/l2r-icons"

import { L2RMenuWithChildren } from "../L2RMenuWithChildren"
import { MoreButton } from "../MoreButton"

import type { MoreMenuWithChildrenProps } from "./MoreMenuWithChildren.types"

export const MoreMenuWithChildren = (props: MoreMenuWithChildrenProps) => {
    const {
        icon,
        menuConfig,
        color = "primary",
        direction = "vertical",
        size = "small",
        onClose,
        ...menuProps
    } = props

    const [menuAnchor, setMenuAnchor] = useState(null)

    const handleMenuOpen = useCallback((event) => {
        event.stopPropagation()
        setMenuAnchor(event.currentTarget)
    }, [setMenuAnchor])

    const handleMenuClose = useCallback(() => {
        setMenuAnchor(null)
    }, [setMenuAnchor])

    const config = useMemo(() => {
        return menuConfig.filter((item) => {
            const { displayed = true } = item
            return displayed
        })
            .map((item) => {
                const { children, enabled = true, id, label, icon, props } = item
                return { children, disabled: !enabled, id, label, icon, props }
            })
    }, [menuConfig])

    if (config.length === 0) {
        return null
    }

    const buttonIcon = icon ? icon : direction === "vertical" ? MoreVertRoundedIcon : MoreHorizRoundedIcon

    return <>
        <MoreButton color={color} size={size} icon={buttonIcon} onClick={handleMenuOpen} />
        <L2RMenuWithChildren
            anchorEl={menuAnchor}
            onClose={(confirmed) => {
                handleMenuClose()
                if (onClose) {
                    onClose(confirmed)
                }
            }}
            open={Boolean(menuAnchor)}
            menuConfig={config}
            {...menuProps}
        />
    </>
}
